import { render, staticRenderFns } from "./LookLessons.vue?vue&type=template&id=46a10900&scoped=true&"
import script from "./LookLessons.vue?vue&type=script&lang=js&"
export * from "./LookLessons.vue?vue&type=script&lang=js&"
import style0 from "./LookLessons.vue?vue&type=style&index=0&id=46a10900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a10900",
  null
  
)

export default component.exports